// extracted by mini-css-extract-plugin
export var displayNone = "_s5-6";
export var imgContainer = "_s5-2";
export var overflowHidden = "_s5-3";
export var productInfoCardButtonContainer = "_s5-5";
export var productTitleText = "_s5-4";
export var rightArrow = "_s5-1";
export var rightArrowContainer = "_s5-0";